import { Brand, LanguageCodeType, Themes } from '../types';
export var DEFAULT = {
  LANGUAGE: LanguageCodeType.ruRU,
  BRAND: Brand.Cloud,
  THEME: Themes.Purple
};
export var POST_MESSAGE_KEY = /*#__PURE__*/function (POST_MESSAGE_KEY) {
  POST_MESSAGE_KEY["changeTheme"] = "changeTheme";
  POST_MESSAGE_KEY["changeThemeDone"] = "changeThemeDone";
  POST_MESSAGE_KEY["changeBrand"] = "changeBrand";
  POST_MESSAGE_KEY["changeBrandDone"] = "changeBrandDone";
  POST_MESSAGE_KEY["changeLanguage"] = "changeLanguage";
  POST_MESSAGE_KEY["changeLanguageDone"] = "changeLanguageDone";
  return POST_MESSAGE_KEY;
}({});